// import { ARCH } from "../../Data/typeDirs"

import { PRE_IMG, REP_V2 } from "../../Data/typeDirs"
import { DROPDIR } from "../../Services/filenameUtils"
import { genId } from "../../utils"


const ARCHDIR = 'Archive'

export class PreambleImage{
  constructor(data = {}){
    this._id = data._id || genId()
    this._createdBy = data._createdBy
    this._modifiedBy= data._modifiedBy || data._createdBy
    this.content = data.content
    this.dbg_id = data.dbg_id
    this.dropboxPath = data.dropboxPath
    this.parentType = data.parentType
    this._parentId = data._parentId
    this.thumbnailSize = data.thumbnailSize || 'md'
    this.type = PreambleImage.getTypeDir()
    this.storageLocation = data.storageLocation || null
  }
  static getTypeDir() { return PRE_IMG }
  static getIndices() { return '_id' }


  static getDropboxPath(_id, dirName){
    return `/${DROPDIR}/${REP_V2}/${dirName}/${PRE_IMG}/${_id}.jpg`
  }

  static getDropboxArchivePath(_id, dirName, parentType){
    return `/${ARCHDIR}/${parentType}/${dirName}/${PRE_IMG}/${_id}.jpg` 
  }

  async getDropboxPath(dirName, dataSource){
    if(!dirName){
      dirName = await dataSource('remDb')[REP_V2].get({_id:this._reports_v2}).dirName
    }
    return PreambleImage.getDropboxPath(this._id)
  }
  async getDropboxArchivePath(dirName, dataSource){
    if(!dirName){
      dirName = await dataSource('remDb')[REP_V2].get({_id:this._reports_v2}).dirName
    }
    return PreambleImage.getArchivePath(this._id)
  }
}